export default __webpack_public_path__ + "static/media/5c.6bda1ccb.png";